export const KEY_SCHEMA_PREFIX = '[key=True].';
export const VERSION_PREFIX = '[version=2.0].';
export const ARRAY_TOKEN = '[type=array]';
export const UNION_TOKEN = '[type=union]';
